import { render, staticRenderFns } from "./bank_details.vue?vue&type=template&id=f88629e6"
import script from "./bank_details.vue?vue&type=script&lang=js"
export * from "./bank_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports